export enum EffectToInit {
  /**
   * Managing the calendar items that consist of availability and assignments data.
   */
  CALENDAR_MANAGEMENT = 'CALENDAR_MANAGEMENT',
  /**
   * Used when creating/updated weekly availability
   */
  AVAILABILITY_SERIES_MANAGEMENT = 'AVAILABILITY_SERIES_MANAGEMENT',
  /**
   * When confirming the actual worktime for slots.
   */
  CONFIRM_SLOTS_ACTUAL_WORKTIME_MANAGEMENT = 'CONFIRM_SLOTS_ACTUAL_WORKTIME_MANAGEMENT',
  /**
   * When creating a new appointment between the logged in user and a pupil.
   */
  NEW_APPOINTMENT_MANAGEMENT = 'NEW_APPOINTMENT_MANAGEMENT',
  SELF_ASSIGNABLE_ASSIGNMENT_MANAGEMENT = 'SELF_ASSIGNABLE_ASSIGNMENT_MANAGEMENT',
  FUTURE_ASSIGNMENT_MANAGEMENT = 'FUTURE_ASSIGNMENT_MANAGEMENT',
  PAST_ASSIGNMENT_MANAGEMENT = 'PAST_ASSIGNMENT_MANAGEMENT',
}
